import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { DeleteService, getService } from "../services/EMRServices/emrServices";
import { DeleteIcon } from "./EmrCommonAsset/Asset";

export default function Services(props) {
  const { serviceData, setServiceData, setDataServices, markFavoriteData } =
    props;

  const [chipsCount, setChipsCount] = useState(5);
  const [selectedChips, setSelectedChips] = useState([]);
  const [unitId, setUnitId] = useState(null);
  const [service, setService] = useState();
  const [isDeletedData, setIsDeletedData] = useState([]);
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext();

  const location = useLocation();
  let roleObj = {};
  useEffect(() => {
    roleObj = JSON.parse(localStorage.getItem("userInfo"));
    setUnitId(roleObj.unitId);
  }, []);

  const DeleteRecord = (Id) => {
    DeleteService(Id)
      .then((response) => {
        if (response?.statusCode === 200) {
          successAlert(response.data.result);
        } else if (response?.data?.statusCode === 400) {
          warningAlert(response?.data?.message);
        }
      })
      .catch((error) => {
        errorAlert(error?.message);
      });
  };

  function deleteRow(row, index) {
    console.log("The response while deleting service :", row);
    const newComplaintsData = [...serviceData];
    const removedItem = newComplaintsData.splice(index, 1)[0];
    setServiceData(newComplaintsData);
    setDataServices(newComplaintsData);
    if (removedItem.id !== null && removedItem.id !== undefined) {
      let deleteFlag = [...serviceData];
      if (deleteFlag?.length > 0) {
        for (let i = 0; i < deleteFlag?.length; i++) {
          if (deleteFlag[i].serviceId === removedItem.serviceId) {
            deleteFlag[i].isDeleteFlag = true;
          }
        }
      }
      setIsDeletedData(deleteFlag);
    }
    if (row.id !== null) {
      // DeleteRecord(row.id);
    }
  }

  const mergeArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.service === val.service);
      if (ind !== -1) {
        console.log("Service Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };
  useEffect(() => {
    console.log("isDeletedData123", isDeletedData);
    if (isDeletedData?.length > 0) {
      setServiceData(isDeletedData);
    }
  }, [isDeletedData]);

  const filteredPathologyData = serviceData?.filter(
    (item) => item.isDeleteFlag === false,
  );
  const handleInputChange = (enteredData) => {
    if (unitId !== null && enteredData !== undefined && enteredData !== "") {
      getService(
        enteredData,
        unitId,
        props.patientVisitedDepartmentId,
        props.doctorId,
      )
        .then((response) => {
          setService(response.data.result);
        })
        .catch((response) => {
          console.log(response);
        });
    } else if (
      enteredData === "" ||
      enteredData === undefined ||
      enteredData === null
    ) {
      setService([]);
    }
  };

  const renderActions = (row, index) => {
    console.log("The rows in the service on the EMR are :", row);

    return (
      <>
        <div className="flex gap-2">
          {!row?.isBilled ? (
            <Tooltip title="Delete">
              <button
                type="button"
                onClick={() => {
                  deleteRow(row, index);
                }}
                disabled={row?.isLab === true || row?.isBilled === true}
              >
                <DeleteIcon />
              </button>
            </Tooltip>
          ) : (
            ""
          )}
        </div>
      </>
    );
  };
  let serviceWatch = watch("service");
  let quantity = watch("quantity");

  useEffect(() => {
    if (
      serviceWatch !== null &&
      serviceWatch !== undefined &&
      serviceWatch !== ""
    ) {
      let obj = {
        serviceId: serviceWatch?.id,
        service: serviceWatch?.label,
        quantity: quantity !== "" ? quantity : 1,
        isNew: true,
        isServiceFlag: true,
        isDeleteFlag: false,
        isTempDelete: false,
      };
      let temp = serviceData?.some(
        (item) => item?.service === serviceWatch?.label,
      );
      let tempSave = serviceData?.some(
        (item) => item?.service === serviceWatch?.label,
      );

      if (temp === true) {
        warningAlert("Already Present Record..!");
      } else {
        if (serviceWatch?.label !== null && serviceWatch?.label !== undefined) {
          setServiceData((prevState) => [...prevState, obj]);
          setValue("service", null);
          setValue("quantity", "");
        } else {
          warningAlert("Please Fill The Record");
        }
      }
    }
  }, [serviceWatch]);

  const mergeServiceArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.serviceId === val.serviceId);
      if (ind !== -1) {
        console.log("Service Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };

  return (
    <div>
      <div className="flex justify-between bg-[#C6CCFF] rounded-t-md ">
        <p className="text-sm font-semibold pl-2 pt-1">Services</p>
        <div className=" w-72 gap-2 flex my-auto">
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            className="w-full"
          >
            <SearchDropdown
              // ref={selectRef}
              focused={true}
              control={control}
              // error={errors.allergyType}
              name="service"
              label="Service"
              placeholder="Service"
              dataArray={service}
              isSearchable={false}
              handleInputChange={handleInputChange}
              // onInputChange={handleInputChange}
              autoFocus
              searchIcon={true}
            />
          </fieldset>
        </div>
      </div>
      <div
        className={`${
          props.from === "cardiology"
            ? "max-h-44 min-h-36"
            : "max-h-44 min-h-36"
        }  overflow-auto border  border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md`}
      >
        <div className="flex justify-between ">
          <div className="flex space-x-2 pl-2">
            <>
              <div className="flex space-x-2 flex-wrap">
                {markFavoriteData &&
                  markFavoriteData?.services
                    .slice(0, chipsCount)
                    .map((item, index) => {
                      const isSelected = selectedChips.includes(item);

                      return (
                        <>
                          <button
                            type="button"
                            // className="border border-black center relative inline-block select-none whitespace-nowrap rounded-full bg-white py-2 px-3.5 align-baseline text-xs  leading-none text-black"
                            key={index}
                            className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                              serviceData?.some(
                                (val) => val?.service === item.label,
                              )
                                ? "bg-[#32819b] text-white rounded-full border"
                                : "text-black rounded-full border"
                            }`}
                            disabled={serviceData.some(
                              (val) => val?.service === item.label,
                            )}
                            onClick={() => {
                              // setSelectedChips([...selectedChips, item]);

                              // setSelectedService(item);
                              // setOpenServicesModal(true);
                              setValue("service", item);
                            }}
                          >
                            {item.label}
                          </button>
                          {/* )}  */}
                        </>
                      );
                    })}
              </div>
            </>
          </div>
        </div>

        {filteredPathologyData?.length > 0 ? (
          <div className="">
            <CommonTransactionTable
              dataResult={mergeServiceArray(filteredPathologyData).map(
                (row) => ({
                  Service: row.service || row?.Investigation,
                  Quantity: row.quantity || 1,
                  id: row?.id,
                  isBilled: row.isBilled,
                  isServiceFlag: row?.isServiceFlag,
                  isDeleteFlag: row?.isDeleteFlag,
                  isLab: row?.isLab,
                  isTempDelete: row?.isTempDelete,
                }),
              )}
              renderActions={renderActions}
              highlightRow={false}
              removeHeaders={[
                "isLab",
                "isDeleteFlag",
                "serviceId",
                "id",
                "isBilled",
                "isServiceFlag",
                "isTempDelete",
              ]}
            />
          </div>
        ) : null}

        <div className=""></div>
      </div>
    </div>
  );
}
